import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import Mailto from "../../commonComponents/Mailto/Mailto";
import ContactUsForm from "./components/ContactUsForm";
import LocationOnSharpIcon from "@mui/icons-material/LocationOnSharp";
import LocalPhoneSharpIcon from "@mui/icons-material/LocalPhoneSharp";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import FadeInBox from "../../commonComponents/FadeInBox";

const contacts = [
  {
    icon: <EmailOutlinedIcon />,
    title: "Email",
    description: "sales@eldeebco.uk",
  },
  {
    icon: <LocalPhoneSharpIcon />,
    title: "Phone Number",
    description: "+44 (0) 7777 130 289",
  },
  {
    icon: <LocationOnSharpIcon />,
    title: "Address",
    description: "15 Poulter Croft, Middleton, Milton Keynes, MK10 9SY",
  },
];
const ContactUs = ({ title = "Get in touch" }) => {
  return (
    <Box
      sx={{
        pt: { xs: 1, md: 5 },
        pb: { xs: 3, md: 5 },

        backgroundColor: "#e1eefa",
      }}
    >
      <Box
        sx={{
          ml: { xs: 2, md: 15 },
          mr: { xs: 2, md: 15 },
          mt: { xs: 2, md: 2 },
        }}
      >
        <FadeInBox delay={0.2} triggerOnScroll={true} triggerOnMount={false}>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { xs: "19px", md: "25px" },
              fontFamily: "Montserrat",
              maxWidth: 500,
            }}
          >
            {title}
          </Typography>
        </FadeInBox>

        <Box
          sx={{
            borderRadius: "10px",
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            gap: { xs: 3, md: 0 },
            marginBottom: { xs: 2, md: 5 },
            marginTop: { xs: 3, md: 2 },
          }}
        >
          {contacts.map((contact, index) => (
            <FadeInBox
              key={index}
              delay={0.3 + index * 0.15}
              triggerOnScroll={true}
              triggerOnMount={false}
            >
              <Box sx={{ display: "flex", flexDirection: "row", columnGap: 2 }}>
                <span style={{ color: "#164B7C" }}> {contact.icon}</span>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: "15px",
                    fontFamily: "Montserrat",
                    maxWidth: "380px",
                  }}
                >
                  {contact.title === "Email" ? (
                    <Mailto emails={contact.description}>
                      {" "}
                      {contact.description}
                    </Mailto>
                  ) : (
                    contact.description
                  )}
                </Typography>
              </Box>
            </FadeInBox>
          ))}
        </Box>
        <FadeInBox delay={0.8} triggerOnScroll={true} triggerOnMount={false}>
          <ContactUsForm />
        </FadeInBox>
      </Box>
    </Box>
  );
};
export default ContactUs;
